export const gradients = [
    "linear-gradient(135deg, #FFA000 0%, #FF6F00 50%, #F57C00 100%)",
    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    "linear-gradient(135deg, #2E3192 0%, #1BFFFF 100%)",
    "linear-gradient(135deg, #FF6B6B 0%, #FFE66D 100%)",
    "linear-gradient(135deg, #134E5E 0%, #71B280 100%)",
    "linear-gradient(135deg, #A8EDEA 0%, #FED6E3 100%)",
    "linear-gradient(135deg, #FF006E 0%, #8338EC 100%)",
    "linear-gradient(135deg, #88D4AB 0%, #6BC5A0 50%, #5BBFBA 100%)",
];
